import { useMutationWithHandler } from './useMutationWithHandler'
import { PresignedGetUrl } from '@/modules/Drive/services'
import { AxiosError } from 'axios'
import { ErrorResponse } from '@/types/shared'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

export const usePresignedGetUrl = () => {
    const { t } = useTranslation()

    const { mutateAsync, isPending } = useMutationWithHandler(
        {
            mutationFn: async (path: string) => {
                const response = await PresignedGetUrl(path)
                return response.result
            },
        },
        {
            reactQueryKeys: QUERY_KEYS.DRIVE,
            showSuccessToast: false,
            onError: (error: AxiosError<ErrorResponse>) => {
                toast.error(
                    t(
                        error?.response?.data?.error_description ||
                            'cannot-get-presigned-url'
                    )
                )
            },
        }
    )

    return {
        getPresignedUrl: mutateAsync,
        isGettingPresignedUrl: isPending,
    }
}
